<form class="employed-contract" [formGroup]="formGroup">
    <h2 class="subtitle" [innerHtml]="copyService.copies.employed_contract_subtitle"></h2>

    <div class="checkbox">
        <voxel-radio-button-group id="contractList">
            <voxel-radio-button *ngFor="let contract of typeContracts" [checked]="contract.checked" (radioButtonChange)="radioButtonChange($event)" [value]="contract">
                {{ contract.label }}
            </voxel-radio-button>
        </voxel-radio-button-group>
    </div>

    <h2 class="subtitle" [innerHtml]="copyService.copies.employed_contract_subtitle_2"></h2>
    <div class="form row">
        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-datepicker language="es"
                [dateLabel]="copyService.copies.employed_contract_date_label"
                [invalidDateErrorMessage]="copyService.copies.employed_contract_date_error"
                [selectedDate]="formGroup.controls.contractDate.value"
                (selectedDateChange)="formGroup.controls.contractDate.setValue($event)"
                [required]="true"></vcl-datepicker>
            <!-- <div class="note">{{ msg }}</div> -->
        </div>
    </div>
</form>

<app-controls id="employedContractBtns" [nextLabel]="copyService.copies.employed_contract_button" [nextDisabled]="formGroup.invalid" (next)="next()"></app-controls>